import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../../client/classes/client';
import { StammdatenService } from '../../stammdaten.service';
import { MatDialog } from '@angular/material/dialog';
import { HitPinAenderDialogComponent } from '../hit-pin-aender-dialog/hit-pin-aender-dialog.component';

@Component({
    selector: 'kiene-vvvo-details-actions',
    templateUrl: './vvvo-details-actions.component.html',
    styleUrls: ['./vvvo-details-actions.component.scss'],
})
export class VvvoDetailsActionsComponent implements OnInit {
    @Input('kunde')
    kunde: Client;
    @Input() showRemove = true;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private stammdatenService: StammdatenService,
        private dialog: MatDialog,
    ) {}

    ngOnInit(): void {}

    openHitPinAendern(): void {
        this.dialog.open(HitPinAenderDialogComponent, { data: this.kunde }).afterClosed().subscribe({});
    }

    removeVVVO() {
        this.stammdatenService.removeVVVO(this.kunde).subscribe({
            next: (removed: boolean) => {
                if (removed === true) {
                    this.router.navigate(['/einstellungen', 'stammdaten', 'vvvo']).then();
                }
            },
        });
    }
}
